export default function (nga, admin, menu) {
    var _ename = 'discountcode';
    var _epretty = 'Códigos de Desconto';
    var _entity = nga.entity(_ename);
    
    _entity.listView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID').isDetailLink(true),
            nga.field('code').label('Código'),
            nga.field('uses_left').label('Utilizações'),
            nga.field('valid_until').label('Utilizações')
        ])
        .sortField('id')
        .sortDir('desc')
        .listActions(['edit', 'show']);

    _entity.showView()
        .title(_epretty)
        .fields([
            nga.field('code').label('Código'),
            nga.field('discount', 'number').label('Desconto'),
            nga.field('uses_left', 'number').label('Utilizações'),
            nga.field('valid_until', 'datetime').label('Utilizações')
        ]);
        
    _entity.editionView()
        .title('Editar ' + _epretty)
        .fields([
            nga.field('code')
                    .attributes({ placeholder: 'Apenas caracteres alfanumericos' })
                    .validation({ required: true, pattern:"\w+", minlength: 5, maxlength: 45 })                    
                    .label('Código'),
            nga.field('discount', 'number')
                    .validation({ required: true, validator: function(value) {
						 if (value < 0 || value >= 100) throw new Error ('Desconto deve conter um número entre 0 e 100');
					 }})
                    .label('Desconto'),
            nga.field('uses_left', 'number')
                    .validation({validator: function(value) {
						 if (value != null && value <= 0) throw new Error ('Código deve conter pelo menos uma utilização');
					 }})
                    .label('Utilizações'),
            nga.field('valid_until', 'datetime').validation({ required: true }).label('Utilizações')
        ]);
   
	
    _entity.creationView()
        .title('Criar um novo ' + _epretty)
        .fields([
            nga.field('code')
                    .attributes({ placeholder: 'Apenas caracteres alfanumericos' })
                    .validation({ required: true, pattern:"\w+", minlength: 5, maxlength: 45 })                    
                    .label('Código'),
            nga.field('discount', 'number')
                    .validation({ required: true, validator: function(value) {
						 if (value < 0 || value >= 100) throw new Error ('Desconto deve conter um número entre 0 e 100');
					 }})
                    .label('Desconto'),
            nga.field('uses_left', 'number')
                    .validation({validator: function(value) {
						 if (value != null && value <= 0) throw new Error ('Código deve conter pelo menos uma utilização');
					 }})
                    .label('Utilizações'),
            nga.field('valid_until', 'datetime')
                    .validation({ required: true })
                    .label('Utilizações')
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/discountcodes.js